import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { TarjetasService } from '../../service/tarjetas.service';
import { Router } from '@angular/router';
import { PerfilService } from 'src/app/service/perfil.service';
import { LoginService } from '../../service/login.service';
import { VerifiCard } from '../../VerifiCard';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as moment from 'moment'
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tarjetas',
  templateUrl: './tarjetas.component.html'
})
export class TarjetasComponent implements OnInit {
  env = false
  new = false;
  nTarjeta: string;
  nomTarjeta: string;
  cardSelected: string
  cards: any;
  titulo_modal: string;
  valid = true
  carga = false
  dni: any
  sesion: any
  dataRes = {
    card: { numTarjeta: 0 }
  };
  nuevaSolicitud = false;
  response: any;
  result: any;
  cardCompro: any
  tituloSolicitud: string = '';
  //creditCardData
  cardNumber: any
  realNumerCard: any
  cardName: any
  cardDate: any;
  cardCuotas = '';
  cardCVV: any;
  cardMonto: any;
  fav = false
  mov: any;
  modalError: any = false;
  modalButton: boolean = false;

  tipoClasif: any;
  desclas: any;
  codSubClass: any;
  numTarjetExt: any;
  bloqueo = '-1';
  clasif: any;
  nombres: any;
  apePaterno: any;
  apeMaterno: any;
  apeCasada: any;
  email: any;
  tel: any;
  monto: any;
  desc: any;
  tipo: any
  sexo: any;
  totalCards: any
  soliciExito = false
  loading = false;
  cardDateReal: any
  errorMonto: any;
  errorMonto2: any;
  error: any;
  date: any;
  hora: any;
  FormatDate: any;
  pinTarjeta: any
  validate = new VerifiCard;


  respuesta: boolean;
  fechaAux = new Date()
  errorFVTC: boolean;
  msjFVTC: string;

  fechNaci: string;

  session: {
    idUsuario: any; ksi: string, dpi: number
  };
  quetzalFormat = {
    digitGroupSeparator: "",
    maximumValue: "999",
    minimumValue: "0",
    decimalPlaces: "0",
    decimalPlacesShownOnBlur: "2",
    modifyValueOnWheel: false,
    onInvalidPaste: "ignore"
  }
  tarjetasAbt: any;


  constructor(private router: Router, private tarjetas: TarjetasService, private perfil: PerfilService,
    private login: LoginService, public dialog: MatDialog) {
    this.tarjetas.selectedCard.subscribe(tarjetas => this.cardSelected = tarjetas);
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi

  }

  ngOnInit() {
    this.cardMonto = ''
    this.cardCuotas = '';
    this.respuesta = false;
    this.nTarjeta = "";
    this.nomTarjeta = "";
  }
  formatDate() {
    this.cardDateReal = this.cardDate
    var test = this.cardDate.match(/.{1,2}/g)
    this.cardDate = '';
    this.cardDate = test[0];
    this.cardDate += '/';
    this.cardDate += test[1]
  }

  deformatDate() {
    this.cardDate = this.cardDate.split('/').join('')
  }

  loaderOff($event) {
    this.dataRes = $event
  }

  edit(nTarjeta: string, nomTarjeta: string, fav: string) {
    this.titulo_modal = "Editar medio de acceso"
    this.new = false
    this.nTarjeta = "";
    this.nomTarjeta = "";
    this.show(true);
    this.nTarjeta = nTarjeta;
    this.nomTarjeta = nomTarjeta;

    this.fav = fav === 'S'


  }
  newCard() {
    this.titulo_modal = "Afiliar medio de acceso"
    this.nTarjeta = "";
    this.nomTarjeta = "";
    this.carga = false;
    this.new = true
    this.show(true);
  }

  addNewCard() {
  if (!this.session || !this.session.ksi || !this.session.idUsuario) {
  this.modalError = 'Sesión inválida. Por favor inicie sesión nuevamente.';
  return;
}

  if(!this.nTarjeta || !this.nomTarjeta) {
    this.modalError = 'Por favor complete todos los campos requeridos.';
    return;
  }
  this.modalButton = true;
  this.modalError = "";
  this.loading = true;

  this.tarjetas.validacionMA(this.nTarjeta).subscribe({
    next: (res: any) => {
      // Normalizamos la respuesta: si viene como string (JSON) parseamos, si ya es objeto lo usamos tal cual
      let response: any;
      if (typeof res === 'string') {
        try {
          response = JSON.parse(res);
        } catch (e) {
          console.error('validacionMA: respuesta no JSON', res, e);
          this.modalError = 'Respuesta inválida del servicio de validación';
          this.modalButton = false;
          this.loading = false;
          return;
        }
      } else {
        // si estamos usando observe: 'response' el body puede estar en res.body
        response = (res && res.body) ? res.body : res;
      }

      // Ahora comprobamos tanto "resultado" (tu nuevo contrato) como la forma antigua estado.numeroError
      const okResultado = response?.resultado === 0;
      const okEstado = response?.estado?.numeroError === 0;
      const isValid = okResultado || okEstado;

      if (isValid) {
        const json = {
          sesion: {
            sIdSesion: this.session.ksi,
            nIdUsuarioWeb: this.session.idUsuario,
            nIdEmpresa: 5,
            sHost: "127.0.0.1"
          },
          nIdUsuarioWeb: this.session.idUsuario,
          sNumTarjeta: this.nTarjeta,
          sEtiqueta: this.nomTarjeta,
          sIndFavorita: "N"
        };
        const jsons = {
          sesion: {
            sIdSesion: this.session.ksi,
            nIdUsuarioWeb: this.session.idUsuario,
            nIdEmpresa: 5,
            sHost: "127.0.0.1"
          },
          nIdUsuarioWeb: this.session.idUsuario,
        };

        this.tarjetas.newCard(json).subscribe({
          next: (r: any) => {
            if (r?.estado?.numeroError == 0) {
              this.respuesta = true;
              this.tarjetas.getCards(jsons).subscribe(resCards => {
                this.tarjetas.addCards(resCards?.resumenTarjetas);
                this.totalCards = this.totalCards + 1;
                this.loading = false;
                this.show(false);
              }, () => {
                // fallback si getCards falla
                this.loading = false;
                this.show(false);
              });
            } else if (r?.estado?.numeroError == 999) {
              this.respuesta = false;
              this.loading = false;
              this.modalError = "Medio de acceso ya se encuentra afiliado al usuario";
            } else {
              this.respuesta = false;
              this.loading = false;
              this.modalError = r?.msjError || 'Error al afiliar medio de acceso';
            }
            this.modalButton = false;
          },
          error: () => {
            this.modalButton = false;
            this.loading = false;
            this.modalError = "Error al afiliar medio de acceso. Inténtelo más tarde.";
          }
        });
      } else {
        // respuesta de validacionMA no válida
        console.warn('validacionMA no valida:', response);
        this.modalButton = false;
        this.loading = false;

        // Si la API devuelve un mensaje descriptivo, lo mostramos
        const msg = response?.mensaje || response?.descripcion || 'Medio de acceso inválido';
        this.modalError = msg;
      }
    },
    error: (err) => {
      console.error('Error en validacionMA:', err);
      this.modalButton = false;
      this.loading = false;
      this.modalError = 'Error en validación de medio de acceso. Inténtelo más tarde.';
    }
  });
}


  confirmarDelete() {
    this.modalButton = true;
    this.modalError = "";
    this.openDialog();
  }

  delete() {
    this.loading = true;
    let json = {
      KSI: this.sesion.idSession,
      numTarjeta: this.nTarjeta,
      idUsuarioWeb: this.sesion.usuarioWeb,
      dni: this.dni.dni,
    }
    this.tarjetas.deleteCard(json).subscribe(res => {
      if (res.numError == 0) {
        this.respuesta = true;
        this.tarjetas.addCards(this.cards.cards.filter(card => card.numTarjeta != this.nTarjeta))   //se elimina tarjeta borrada
        this.totalCards = this.totalCards - 1;
        if (this.totalCards < 1) {
          this.router.navigate(['pocae/resumen/'])
        }
        this.loading = false;
        this.show(false)
      } else {
        this.respuesta = false;
        this.loading = false;
        this.modalError = res.msjError
      }
    }, () => {
      this.loading = false;
      this.modalError = "Error al desafiliar tarjeta. Inténtelo más tarde.";
    })
  }

  onlyNumber(event: KeyboardEvent) {
    const allowedControlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
    if (event.ctrlKey || event.metaKey) {
      // permitir combinaciones Ctrl/Cmd (ej: copiar), aunque pegado será bloqueado por paste handler
      return;
    }
    if (allowedControlKeys.includes(event.key)) {
      return;
    }
    // bloquear dead keys (acento agudo, tilde compuesta, etc.)
    if (event.key === 'Dead') {
      event.preventDefault();
      return;
    }
    // permitir solo 0-9
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    // opcional: mostrar mensaje al usuario si quieres
    // this.showToast('Pegado no permitido — ingrese manualmente el número');
  }


  // bloquear drop (arrastrar/soltar)
  onDrop(event: DragEvent) {
    event.preventDefault();
    // opcional: mostrar mensaje
  }

// sincronizar y limpiar si por alguna razón ingresó algo extraño
  onInputNgModel(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleaned = (input.value || '').replace(/\D+/g, ''); // solo dígitos
    if (input.value !== cleaned) {
      input.value = cleaned;
      this.nTarjeta = cleaned;
    } else {
      // mantener variable sincronizada (útil si ngModel no lo hizo automáticamente)
      this.nTarjeta = input.value;
    }
  }




  validaFechaTC() {
    this.errorFVTC = false;
    const x = moment()
    const aux = moment(this.cardDate, 'MMYY');
    const month = new Date().getMonth() + 1
    const year = new Date().getFullYear().toString().substring(2)

    if (this.cardDate.substr(0, 2) <= 12) {
      if (month + year == this.cardDate) this.errorFVTC = false;
      else {
        this.errorFVTC = moment(aux).isBefore(x)
        this.msjFVTC = "Fecha no puede ser menor a la actual."
      }
    }
    else {
      this.errorFVTC = true;
      this.msjFVTC = "No existe mes " + (this.cardDate.substr(0, 2)) + "."
    }
  }


  deFormat() {
    this.cardNumber = this.cardNumber.split(' ').join('');
  }

  tagCard() {
    this.modalButton = true;
    let json = {
      KSI: this.sesion.idSession,
      numTarjeta: this.nTarjeta,
      etiqueta: this.nomTarjeta,
      indFavorita: this.fav ? "S" : "N",
      idUsuarioWeb: this.sesion.usuarioWeb,
    }

    let jsons = {
      KSI: this.sesion.idSession,
      idUsuarioWeb: this.sesion.usuarioWeb
    }

    this.tarjetas.tagCard(json).subscribe(res => {
      this.response = res;
      if (this.response.numError != 0) {
        this.modalError = this.response.msjError
        if (this.response.numError == 2400) {
          this.login.addSession('', '', '', '', '');
        }
      } else {
        if (res.numError === 0) {
          this.tarjetas.getCards(jsons).subscribe(res => {
            this.tarjetas.addCards(res.resumen)
            this.show(false)
          })
        }
      }
    }, () => {
      this.loading = false;
      this.respuesta = false;
      this.modalButton = false;
      this.modalError = "Error al intentar editar tarjeta. Intente más tarde.";
    })
  }

  favCard(numTarjeta, fav) {
    this.fav = !fav
  }

  comprobante() {
    this.titulo_modal = "Comprobante de Compra"
    this.new = false;
    this.carga = false;
    this.result = true;
  }
  solicitud(response: boolean) {
    this.nuevaSolicitud = response
  }
  show(cerrar: boolean) {
    this.pinTarjeta = '';
    this.carga = false;
    this.result = false

    if (!cerrar) {
      this.modalError = "";
      this.cardMonto = ''
    }
    else {
      this.modalButton = false;
      this.error = false;
    }
    this.env = cerrar
    this.cardCVV = '';
    this.cardCuotas = '';
    this.cardNumber = '';
    this.cardDate = '';
    this.cardName = '';
    this.validaFechaTC();
    this.valid = true;
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogDesafiliacion, {
      data: {
        numeroTarjeta: this.nTarjeta
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete()
      }
      this.modalButton = false;
    });
  }
}

export interface DialogData {
  numeroTarjeta: number;
}

@Component({
  selector: 'dialog-desafiliacion',
  templateUrl: 'dialog-desafiliacion.html',
})
export class DialogDesafiliacion {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }
}